import { createContext, useContext } from 'react';
export var View;
(function (View) {
  View["LISTINGS"] = "listings";
  View["MAP"] = "map";
})(View || (View = {}));
export const ViewTrackerContext = createContext({});
export function useViewTrackerContext() {
  return useContext(ViewTrackerContext);
}